import { Link } from "react-router-dom";
import { NAV_LINKS, CONTACT, LOGO } from "../data/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-ink text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-6">
            <div className="inline-flex items-center rounded-xl bg-white px-4 py-3">
              <img src={LOGO} alt="Million Words LLC" className="h-9 w-auto" />
            </div>
            <p className="mt-6 max-w-sm text-white/50 leading-relaxed">
              A video is worth a million words. Immersive media, digital
              learning and creative production.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/40">
              Explore
            </div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/40">
              Contact
            </div>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="text-white/70 hover:text-white transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.phoneHref}
                  className="text-white/70 hover:text-white transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-sm text-white/40">
            © {new Date().getFullYear()} Million Words LLC. All rights reserved.
          </span>
          <span className="text-sm text-white/40">Crafted for the immersive era.</span>
        </div>
      </div>
    </footer>
  );
};
